
<div class="embed-dashboard-container"
     [class.embed-dashboard__no-interaction]="disableInteraction()"
     [class.embed-dashboard__print]="print()"
     [class.embed-dashboard__has-focused]="!!focused()"
     #container
     (click)="onClick($event)">
  <div class="embed-dashboard__content"
       [style.--dashboard-page-count]="pageCount()"
       [style.--dashboard-page-height]="pageHeightCss()"
       [style.--dashboard-page-minHeight]="minPageHeightCss()"
       [style.--dashboard-page-header-height]="pageHeaderHeight()"
       [style.--dashboard-page-footer-height]="pageFooterHeight()"
       [style.--dashboard-page-grid-rows]="layoutRows()"
       [style.--dashboard-page-grid-gap]="layoutGap()">
    <div class="embed-dashboard-pages">
    @for (p of pages(); track p)
    {
      <div class="embed-dashboard-page"
           [class.embed-dashboard__page-focused]="focused() && focused().page() == p">
        @if (pageHeaderHeight()) {
          <div class="embed-dashboard__page-header" [style.height]="pageHeaderHeight()">
          @if (pageHeader()) {
            <ng-container *ngTemplateOutlet="pageHeader(); context: { pageIndex: p.index, pages: pages() }"></ng-container>
          }
          </div>
        }

        <div class="embed-dashboard__page-content">
          <div class="embed-dashboard__grid" 
               [class.embed-dashboard__grid-focused]="!!focused()"
               [style]="p.layoutGridStyle()">
            @for (v of p.visuals(); track v)
            {
              <div class="embed-dashboard__visual"
                   [class.embed-dashboard__visual-focused]="v == focused()"
                   [style]="v.layoutStyle()">
                <div class="embed-dashboard__visual-inner"
                     [style]="v.innerLayoutStyle()">
                @if (v.willRender())
                  {
                <visual-embed #visualEmbed
                              [print]="print()"
                              [busy]="busy()"
                              [visualId]="v.dashboardVisualDto.visualId"
                              (visualRendered)="onVisualRendered(v)"
                              [disableTitle]="disableTitle()"
                              [disableActions]="disableActions()"
                              [disableInteraction]="disableInteraction()"
                              [allowApiDownloadLinkDialog]="allowApiDownloadLinkDialog()"
                              [allowExport]="allowExport()"
                              [showFocusToggle]="showFocusToggle()"
                              [focused]="v == focused()"
                              (focusedChange)="focusVisual(v)"
                              [showRowCount]="false"
                              [interactions]="visualInteractions()"
                              [locale]="locale()"
                              (beforeVisualEvent)="onBeforeVisualEvent($event)"
                              (visualEvent)="onVisualEvent($event)"></visual-embed>
                }
                </div>
              </div>
            }
          </div>
        </div>

        @if (pageFooterHeight()) {
          <div class="embed-dashboard__page-footer" [style.height]="pageFooterHeight()">
          @if (pageFooter()) {
            <ng-container *ngTemplateOutlet="pageFooter(); context: { pageIndex: p.index, pages: pages() }"></ng-container>
          }
          </div>
        }
      </div>
    }
    </div>
  </div>
      
  <div class="embed-dashboard__overlay" [class.visible]="!canRender()">
    <div class="d-flex align-items-center flex-dir-row nowrap">
      @if (contentState() == ContentLoadState.Loading ||
           contentState() == ContentLoadState.Refreshing) {
        <div>
          <div class="fs-20">
            <span [hidden]="contentState() != ContentLoadState.Loading">Loading dashboard...</span>
            <div [hidden]="contentState() != ContentLoadState.Refreshing">
              <span>Refreshing data...</span>
              <span>Loaded {{userDatasetCount()}} out of {{loadedUserDatasetCount()}} datasets...</span>
            </div>
          </div>
          <div class="mt-2 mb-15 fs-12 c-grey-1">
            <span>Stay tuned to see your data.</span>
          </div>
        </div>
        <app-spinner class="p-relative not-5 ml-10" [diameter]="36" [strokeWidth]="5"></app-spinner>
      }
      @else if (contentState() == ContentLoadState.Unavailable) {
        <span [hidden]="contentState() != ContentLoadState.Unavailable">
          This dashboard is unavailable.
        </span>
      }
      @else if (contentState() == ContentLoadState.Deleted) {
        <span [hidden]="contentState() != ContentLoadState.Deleted">
          This dashboard is deleted.
        </span>
      }
      @else if (contentState() == ContentLoadState.Error) {
        <span [hidden]="contentState() != ContentLoadState.Error">
          An error occurred when loading this dashboard.
        </span>
      }
    </div>
  </div>
</div>
